import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { FeatureFlagsService } from '../services/feature-flags.service';

/**
 * Public Terms page — only when the server says showTerms === true.
 * Fail closed: if flags are not loaded yet, or the value is not strictly true,
 * the route does not match (no lazy chunk, no content).
 */
export const termsFeatureCanMatch: CanMatchFn = () =>
  inject(FeatureFlagsService).termsEnabled();

export const termsFeatureGuard: CanActivateFn = () => {
  if (inject(FeatureFlagsService).termsEnabled()) {
    return true;
  }
  return inject(Router).createUrlTree(['/']);
};
